export enum SettingsType {
  Company = 0,
  User = 1,
}

export type CreatePcfSettingsDto = {
  advancedSettings?: string;
  allTags?: string;
  bomParameters?: string;
  isoParameters?: string;
  validationMap?: string;
  name?: string;
  settingsType: SettingsType | 'Company' | 'User';
};

export type SettingInfoDto = {
  name: string;
  createdOn: string;
  changedOn: string;
  settingsType: SettingsType;
};

export type PcfSettingsDto = {
  advancedSettings: string;
  allTags: string;
  bomParameters: string;
  isoParameters: string;
  validationMap: string;
  settingsType: SettingsType;
};

export interface PcfSettingsDebugSummary {
  settingsType: SettingsType;
  workflowOption: string | null;
  selectedObjectType: string;
  hasSkeyMapping: boolean;
  hasObjectTypeMapping: boolean;
  connectorBindings: {
    endpoint1: boolean;
    endpoint2: boolean;
    endpoint3: boolean;
    endpoint4: boolean;
    material: boolean;
    designStd: boolean;
    pressureClass: boolean;
  };
  processFlags: {
    processConditionsChecked: boolean;
    projectPropertiesChecked: boolean;
  };
  parameterTargets: {
    connector: string | null;
    bolt: string | null;
    additionalCategories: string | null;
    mappingRepair: string | null;
  };
  counts: {
    projectParameters: number;
    systemParameters: number;
    bomParameters: number;
    isoObjectTypes: number;
    isoAttributes: number;
    validationEntries: number;
  };
  validationKeys: string[];
}

export interface PcfSettingsStoreDebugSnapshot {
  selectedWorkflowOption: string | null;
  menu: {
    objectTypeValue: string;
    sKeyValue: string;
    pipingSpecValue: string;
    systemGroupingValue: string;
    groupingParameterName: string;
    groupingParameterSource: 'Element' | 'Type';
  };
  connector: {
    endpoint1Value: string;
    endpoint2Value: string;
    endpoint3Value: string;
    endpoint4Value: string;
    materialValue: string;
    designStdValue: string;
    pressureClassValue: string;
    insulationSpecValue: string;
    insulationThicknessValue: string;
    weightValue: string;
    tracingSpecValue: string;
    itemDescriptionValue: string;
  };
  process: {
    processConditionsChecked: boolean;
    projectPropertiesChecked: boolean;
    pipingSpecValuePC: string;
    tracingSpecValuePC: string;
    projectIdentifierValue: string;
    areaValue: string;
  };
  bolt: {
    boltSetActiveValue: string;
    boltBaseFamilyValue: string;
    boltModelingChoice: string;
    boltDiaValue: string;
    boltQuantityValue: string;
    boltLengthValue: string;
    boltItemDescriptionValue: string;
    boltMaterialValue: string;
    boltStandardValue: string;
  };
  mapping: {
    allObjectTypeAttributeCount: number;
    allObjectTypeMappedAttributeCount: number;
    projectPropertiesCount: number;
    pipingSystemPropertiesCount: number;
  };
}

export interface SaveCurrentConfigurationTraceResult {
  savedVia: 'api';
  profileName: string;
  settingsType: SettingsType;
  summary: PcfSettingsDebugSummary;
}
